import {useEffect} from 'react';

export function useOnClickOutside(ref, handler, exceptional) {
  useEffect(() => {
    const listener = (event) => {
      if (
        !ref.current ||
        ref.current.contains(event.target) ||
        exceptional.current.contains(event.target)
      ) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, exceptional]);
}

export function createGlobalVariableForEntities(data) {
  let projects = data.projects;
  window.annotations = {};

  for (let i = 0; i < projects.length; i++) {
    let project_id = projects[i].id; // each row id in table
    // init variables
    window.annotations[project_id] = {};

    window.annotations[project_id].folderNames = ["New Folder"];
    window.annotations[project_id].selectedFolderName = "New Folder";
    window.annotations[project_id].markerNames = [];
    window.annotations[project_id].lineNames = [];
    window.annotations[project_id].polygonNames = [];
    window.annotations[project_id].volumeNames = [];
    window.annotations[project_id].markerNames[window.annotations[project_id].selectedFolderName] = [];
    window.annotations[project_id].lineNames[window.annotations[project_id].selectedFolderName] = [];
    window.annotations[project_id].polygonNames[window.annotations[project_id].selectedFolderName] = [];
    window.annotations[project_id].volumeNames[window.annotations[project_id].selectedFolderName] = [];

    window.annotations[project_id].entities = {};
    window.annotations[project_id].entities[window.annotations[project_id].selectedFolderName] = {};
    window.annotations[project_id].entities[window.annotations[project_id].selectedFolderName]["line"] = {};
    window.annotations[project_id].entities[window.annotations[project_id].selectedFolderName]["marker"] = {};
    window.annotations[project_id].entities[window.annotations[project_id].selectedFolderName]["polygon"] = {};
    window.annotations[project_id].entities[window.annotations[project_id].selectedFolderName]["volume"] = {};
  }

  iterate_entity_table(data.annotations)
}

export function iterate_entity_table(table_rows) {
  window.table_rows = table_rows;
  // iterate annotation table rows and set to global variables
  for (let i = 0; i < table_rows.length; i++) {
    let table_row = table_rows[i];
    let project_id = table_row.project_id;
    let folder_name = table_row.folder_name;
    let entity_type = table_row.type;
    let entity_name = table_row.name;

    // draw entity according to entity_color and entity_position
    if (!window.annotations[project_id].entities[folder_name]) {
      window.annotations[project_id].entities[folder_name] = {};
    }
    if (!window.annotations[project_id].entities[folder_name]["line"]) {
      window.annotations[project_id].entities[folder_name]["line"] = {};
    }
    if (!window.annotations[project_id].entities[folder_name]["marker"]) {
      window.annotations[project_id].entities[folder_name]["marker"] = {};
    }
    if (!window.annotations[project_id].entities[folder_name]["polygon"]) {
      window.annotations[project_id].entities[folder_name]["polygon"] = {};
    }
    if (!window.annotations[project_id].entities[folder_name]["volume"]) {
      window.annotations[project_id].entities[folder_name]["volume"] = {};
    }

    if (!window.annotations[project_id].lineNames[folder_name]) {
      window.annotations[project_id].lineNames[folder_name] = [];
    }
    if (!window.annotations[project_id].markerNames[folder_name]) {
      window.annotations[project_id].markerNames[folder_name] = [];
    }
    if (!window.annotations[project_id].polygonNames[folder_name]) {
      window.annotations[project_id].polygonNames[folder_name] = [];
    }
    if (!window.annotations[project_id].volumeNames[folder_name]) {
      window.annotations[project_id].volumeNames[folder_name] = [];
    }
    switch (entity_type) {
      case "line":
        window.annotations[project_id].lineNames[folder_name].push(entity_name);
        break;
      case "marker":
        window.annotations[project_id].markerNames[folder_name].push(entity_name);
        break;
      case "polygon":
        window.annotations[project_id].polygonNames[folder_name].push(entity_name);
        break;
      case "volume":
        window.annotations[project_id].volumeNames[folder_name].push(entity_name);
        break;
      default:
        break;
    }

    if (window.annotations[project_id].folderNames.indexOf(folder_name) === -1) {
      window.annotations[project_id].folderNames.push(folder_name);
      window.annotations[project_id].selectedFolderName = folder_name;
    }
  }
}

export function createUserGlobalVariableForEntities(data) {

  window.annotations = {};
  window.annotations.folderNames = [];
  window.annotations.markerNames = [];
  window.annotations.lineNames = [];
  window.annotations.polygonNames = [];
  window.annotations.volumeNames = [];
  window.annotations.entities = {};

  iterate_user_entity_table(data.annotations);
}

export function iterate_user_entity_table(table_rows) {
  window.table_rows = table_rows;
  // iterate annotation table rows and set to global variables
  for (let i = 0; i < table_rows.length; i++) {
    let table_row = table_rows[i];
    let project_id = table_row.project_id;
    let folder_name = table_row.folder_name;
    let entity_type = table_row.type;
    let entity_name = table_row.name;

    let id = table_row.id;

    if (i === 0) {
      window.annotations.selectedFolderName = folder_name;
      window.annotations.markerNames[window.annotations.selectedFolderName] = [];
      window.annotations.lineNames[window.annotations.selectedFolderName] = [];
      window.annotations.polygonNames[window.annotations.selectedFolderName] = [];
      window.annotations.volumeNames[window.annotations.selectedFolderName] = [];

      window.annotations.entities = {};
      window.annotations.entities[window.annotations.selectedFolderName] = {};
      window.annotations.entities[window.annotations.selectedFolderName]["line"] = {};
      window.annotations.entities[window.annotations.selectedFolderName]["marker"] = {};
      window.annotations.entities[window.annotations.selectedFolderName]["polygon"] = {};
      window.annotations.entities[window.annotations.selectedFolderName]["volume"] = {};
    }

    // draw entity according to entity_color and entity_position
    if (!window.annotations.entities[folder_name]) {
      window.annotations.entities[folder_name] = {};
    }
    if (!window.annotations.entities[folder_name]["line"]) {
      window.annotations.entities[folder_name]["line"] = {};
    }
    if (!window.annotations.entities[folder_name]["marker"]) {
      window.annotations.entities[folder_name]["marker"] = {};
    }
    if (!window.annotations.entities[folder_name]["polygon"]) {
      window.annotations.entities[folder_name]["polygon"] = {};
    }
    if (!window.annotations.entities[folder_name]["volume"]) {
      window.annotations.entities[folder_name]["volume"] = {};
    }

    if (!window.annotations.lineNames[folder_name]) {
      window.annotations.lineNames[folder_name] = [];
    }
    if (!window.annotations.markerNames[folder_name]) {
      window.annotations.markerNames[folder_name] = [];
    }
    if (!window.annotations.polygonNames[folder_name]) {
      window.annotations.polygonNames[folder_name] = [];
    }
    if (!window.annotations.volumeNames[folder_name]) {
      window.annotations.volumeNames[folder_name] = [];
    }
    switch (entity_type) {
      case "line":
        //window.annotations.lineNames[folder_name].push(entity_name);
        window.annotations.lineNames[folder_name].push([entity_name, id]);
        break;
      case "marker":
        window.annotations.markerNames[folder_name].push(entity_name);
        //window.annotations.markerNames[folder_name].push(entity_name.split("_")[0]);
        break;
      case "polygon":
        //window.annotations.polygonNames[folder_name].push(entity_name);
        window.annotations.polygonNames[folder_name].push([entity_name, id]);
        break;
      case "volume":
        window.annotations.volumeNames[folder_name].push(entity_name);
        break;
      default:
        break;
    }

    if (window.annotations.folderNames.indexOf(folder_name) === -1) {
      window.annotations.folderNames.push(folder_name);
      window.annotations.selectedFolderName = folder_name;
    }
  }
}

export function DEBUG_FASTMAP(params) {
  console.log("DEBUG FASTMAP INFO: ", params);
}

export function getErrorMessage(response) {
  if (response == null) {
    return null;
  } else if (response?.data?.message) {
    return response?.data?.message;
  } else if (typeof response?.data?.messages === 'object') {
    for (const [key, value] of Object.entries(response?.data?.messages)) {
      return value;
    }
  } else {
    return response?.data?.messages[0];
  }
}
